// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Nuttig?',
  helpful: 'Nuttig',
  not_helpful: 'Niet nuttig',
  thanks: 'Bedankt, genoteerd.',
};
